import { Component } from '.';

function addChild(parent, child) {
    if (typeof child == 'string') {
        parent.appendChild(document.createTextNode(child));
    } else if (child instanceof Component) {
        child.render(parent);
    } else {
        parent.appendChild(child);
    }
}

function jsxs(name, attrs) {
    let elem = document.createElement(name);
    for (let attr in attrs) {
        if (attr == 'children') {
            let children = attrs[attr];
            if (Array.isArray(children)) {
                children.forEach((child) => {
                    addChild(elem, child);
                });
            } else {
                addChild(elem, children);
            }
        } else if (attr.startsWith('on')) {
            elem.addEventListener(attr.substring(2), attrs[attr]);
        } else {
            elem.setAttribute(attr, attrs[attr]);
        }
    }
    return elem;
}

let jsx = jsxs;

function Fragment() {
    console.log('Fragment', arguments);
    throw 'unimplemented';
}

export { jsx, jsxs, Fragment };
